// Toast surface — thin wrapper over `sonner`, themed to the design
// tokens. Mount <Toaster /> once near the app root; call `toast(...)` /
// `toast.success(...)` / `toast.error(...)` from anywhere.
//
// Per-type backgrounds (success / warning / error) use the design-token
// hues so they're immediately recognisable at a glance. The default
// toast (`toast(...)`) keeps the neutral card background.

import { Toaster as SonnerToaster, toast } from "sonner";

export function Toaster(props: React.ComponentProps<typeof SonnerToaster>) {
  return (
    <SonnerToaster
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast: "group rounded-lg border bg-card text-card-foreground shadow-lg",
          title: "font-medium",
          description: "text-[13px] opacity-90",
          actionButton:
            "bg-background/20 text-current rounded-md text-xs px-2 py-1 hover:bg-background/30",
          cancelButton:
            "bg-background/10 text-current rounded-md text-xs px-2 py-1 hover:bg-background/20",
          success: "!bg-success !text-success-foreground !border-success",
          warning: "!bg-warning !text-warning-foreground !border-warning",
          error: "!bg-destructive !text-destructive-foreground !border-destructive",
          info: "!bg-primary !text-primary-foreground !border-primary",
        },
      }}
      {...props}
    />
  );
}

export { toast };
